import { render, staticRenderFns } from "./UiPagination.vue?vue&type=template&id=412f6636&"
import script from "./UiPagination.vue?vue&type=script&lang=js&"
export * from "./UiPagination.vue?vue&type=script&lang=js&"
import style0 from "./UiPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports